import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle2, XCircle } from 'lucide-react';

import { API } from '../../config';

const AdminScrapeLogs = () => {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    const load = async () => {
      const t = localStorage.getItem('tp_admin_token');
      const r = await axios.get(`${API}/admin/scrape-logs`, { headers: { Authorization: `Bearer ${t}` } });
      setLogs(r.data);
    };
    load();
    const intv = setInterval(load, 10000);
    return () => clearInterval(intv);
  }, []);

  const sourceStats = logs.reduce((a, l) => {
    const key = l.source_site || l.source;
    if (!a[key]) a[key] = { total: 0, success: 0 };
    a[key].total += 1;
    if (l.success) a[key].success += 1;
    return a;
  }, {});

  return (
    <div>
      <h1 className="text-2xl font-bold text-[#0B2E5C]">Scraping Logs</h1>
      <p className="text-sm text-gray-500 mb-5">Live-updating logs from PNR & Live Status scrapers (auto refresh 10s). Source site is shown so wrong data can be traced back to the upstream scraper.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
        {Object.entries(sourceStats).map(([s, v]) => {
          const rate = v.total ? Math.round((v.success / v.total) * 100) : 0;
          return (
            <div key={s} data-testid={`stat-${s}`} className="bg-white rounded-xl p-4 border border-gray-100 card-shadow">
              <div className="text-xs text-gray-500 uppercase break-all">{s}</div>
              <div className="text-2xl font-bold text-[#0B2E5C]">{rate}%</div>
              <div className="text-xs text-gray-500">{v.success} / {v.total} calls</div>
            </div>
          );
        })}
      </div>

      <div className="bg-white rounded-xl border border-gray-100 card-shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase">
            <tr>
              <th className="text-left py-3 px-4">Time</th>
              <th className="text-left py-3 px-4">Type</th>
              <th className="text-left py-3 px-4">Query</th>
              <th className="text-left py-3 px-4">Source Site</th>
              <th className="text-left py-3 px-4">Latency</th>
              <th className="text-left py-3 px-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {logs.slice(0, 100).map(l => (
              <tr key={l.id} className="border-t" data-testid={`log-row-${l.id}`}>
                <td className="py-2 px-4 text-xs text-gray-500">{new Date(l.created_at).toLocaleTimeString()}</td>
                <td className="py-2 px-4 text-xs font-semibold uppercase">{l.type}</td>
                <td className="py-2 px-4 font-mono text-xs">{l.query}</td>
                <td className="py-2 px-4 text-xs">
                  <div className="font-semibold text-[#0B2E5C]">{l.source_site || l.source}</div>
                  <div className="text-[10px] text-gray-400 uppercase">{l.source}</div>
                </td>
                <td className="py-2 px-4 text-xs">{l.latency_ms} ms</td>
                <td className="py-2 px-4">{l.success ? <span className="text-green-600 flex items-center gap-1 text-xs"><CheckCircle2 size={12} /> success</span> : <span className="text-red-500 flex items-center gap-1 text-xs"><XCircle size={12} /> {l.error || 'failed'}</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs.length === 0 && <div className="text-center py-10 text-gray-400">No scrape activity yet — try checking a PNR or train status</div>}
      </div>
    </div>
  );
};

export default AdminScrapeLogs;
